export default __webpack_public_path__ + "media/images/mailer/logo_full-403b7403932b6e610422065780acfa64.png";